// Pages/VincularCategoria/index.tsx
import { useState, useContext, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import { FaLink } from 'react-icons/fa';
import { ThemeContext } from '../../context/theme-context';
import { ModalVincularCategoria } from '../../Components/ModalVincularCategoria';
import * as S from './styled';

export function VincularCategoria() {
  const { collapsed } = useContext(ThemeContext);
  const [showModal, setShowModal] = useState(false);

  // Abre o modal automaticamente ao carregar a página
  useEffect(() => {
    setShowModal(true);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Container className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}>
      <S.PageWrapper>
        <S.HeaderCard>
          <Card>
            <Card.Body>
              <S.HeaderContent>
                <FaLink size={28} />
                <div>
                  <h4>Vincular Categorias ao Perfil Fiscal</h4>
                  <p>Gerencie a vinculação de múltiplas categorias aos perfis fiscais de forma rápida e eficiente.</p>
                </div>
              </S.HeaderContent>
            </Card.Body>
          </Card>
        </S.HeaderCard>
      </S.PageWrapper>

      <ModalVincularCategoria 
        show={showModal} 
        onHide={handleCloseModal} 
      />
    </Container>
  );
}

export default VincularCategoria;